import { toastPool } from '../features/toasts/models/toast-pool';
import { Toast } from '../features/toasts/models/toast';

export const catchError = (e: any) => {
  if (!(e.response?.status === 401)) {
    toastPool.insert(new Toast('An unexpected error occurred, try again later.', 'error'));
  }
};
